import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 2.67992C4 1.36775 5.36808 0.563755 6.43065 1.25146L17.741 8.57154C18.753 9.22649 18.753 10.7735 17.741 11.4285L6.43066 18.7485C5.36808 19.4362 4 18.6322 4 17.3201V2.67992Z",
		fill: "white"
	})
});
export default SvgPlay;
